import TranslateCategory from "@/views/admin/translate/TranslateCategory";

export default {
  path: "translate/category",
  name: "TranslateCategory",
  component: TranslateCategory,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
